<template>
  <div id="direcciones">
    <b-row v-for="(direccion, index) in arrayDirecciones" :key="index" class="direccion">
      <b-col md="2" class="mt-3"><i class="icon-location3 mr-2"/></b-col>
      <b-col md="10">
        <div class="nombre">{{ direccion.mscdNombre }}</div>
        <div class="calle">{{ direccion.mscdCalle }}</div>
        <div class="localidad">{{ direccion.mscdCp }} {{ direccion.mscdPoblacion }}</div>
        <div class="pais">{{ direccion.pais.mspaisnomesp }}</div>
      </b-col>
    </b-row>
    <v-dialog v-model="dialog">
      <template v-slot:activator="{ on }">
        <v-btn @click="componentKey += 1" icon flat right absolute class="primary" v-on="on" bottom>
          <v-icon>add</v-icon>
        </v-btn>
      </template>
      <v-card class="search">
        <v-toolbar flat class="d-flex justify-space-between">
          <v-toolbar-title class="primary-color">
            <v-icon class="mr-3 primary-color">person_add</v-icon>
            Añadir direcciones</v-toolbar-title
          >
          <v-btn @click="dialog = false" icon flat class="primary-color">
            <!--<img class='btn-footer-izq pointer' src='@/assets/images/Btn-ESC.gif' >-->
            <!--{{ $t('lang.comun.salir') }}-->
            <v-icon>close</v-icon>
          </v-btn></v-toolbar
        >
        <v-card-text>
          <modal-direccion :key="componentKey" :direcciones="arrayDirecciones"></modal-direccion>
        </v-card-text>
      </v-card>
    </v-dialog>
  </div>
</template>
<script>
import ModalDireccion from '../main/ModalDireccion';
import { ClienteDireccionesApiService } from '@/api/ClienteDireccionesApiService';

const clienteDireccionesApi = new ClienteDireccionesApiService();
export default {
  name: 'clienteDirecciones',
  components: {
    ModalDireccion,
  },
  data() {
    return {
      modal: false,
      arrayDirecciones: [],
      componentKey: 0,
      dialog: false,
    };
  },
  created() {
    this.init();
  },
  methods: {
    openModal() {
      this.modal = true;
    },
    init() {
      this.getDireccionesByCliente();
    },
    getDireccionesByCliente() {
      clienteDireccionesApi
        .getDireccionesByCliente(this.$store.getters.getCliente.uid)
        .then((data) => {
          this.arrayDirecciones = data;
        })
        .catch((error) => {
          console.log(error);
        });
    },
  },
};
</script>
